import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import ResumeHandler from './../../_common/_props/PrimerResumeHandlerPropsIos.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`func primerDidResumeWith(_:decisionHandler:)
`}</code></pre>
    <p>{`This method will be called providing a `}<inlineCode parentName="p">{`resumeToken`}</inlineCode>{` so you can resume the payment.`}<br /><br />{`
⚠️ This method will be called only on the manual flow when the payment is in a `}<inlineCode parentName="p">{`.PENDING`}</inlineCode>{` state..`}</p>
    <h3>{`Parameters`}</h3>
    <Group summary='parameters' open mdxType="Group">
	<Item title='resumeToken' subtitle='String' label='Required' mdxType="Item"></Item>
	<ResumeHandler mdxType="ResumeHandler" />
    </Group>
    <h3>{`Example`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-swift"
      }}>{`// 👇 Add this
import PrimerSDK

// 👇 Conform to PrimerDelegate
class MyViewController: UIViewController, PrimerDelegate {

    // ...

    // 👇 Add this
    func primerDidResumeWith(_ resumeToken: String, decisionHandler: @escaping (PrimerResumeDecision) -> Void)
        // Resume your payment
        resumePayment(with: resumeToken) { res, err in
            if let err = err {
                // 👇 Call the decisionHandler to show the error screen with your custom error message
                decisionHandler(.fail(withErrorMessage: "Oh no, something went wrong creating the payment..."))

            } else if let res = res {
                if let newClientToken = res.requiredAction?.clientToken {
                    // 👇 Call the decisionHandler with the new client token to continue the flow
                    decisionHandler(.continueWithNewClientToken(requiredAction.clientToken))
                } else {
                    // 👇 Call the decisionHandler to show the success screen
                    decisionHandler(.succeed())
                }
            }
        }
    }
}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      